import React, { useState } from 'react';
import { faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Task } from '../../types';
import { TaskCompletionButton } from './TaskCompletionButton';

interface ScheduleSubtasksProps {
    collectionId: string;
    onToggleSubtask: (taskId: string, collectionId: string) => void;
    subtasks: Task[];
}

const ScheduleSubtask: React.FC<Omit<ScheduleSubtasksProps, 'subtasks'> & { subtask: Task }> = ({
    collectionId, onToggleSubtask, subtask,
}) => {
    const [expanded, setExpanded] = useState(false);
    const children = subtask.subtasks || [];
    return <div className="schedule-subtask-tree">
        <div className={`schedule-subtask ${subtask.completed ? 'completed' : ''}`}>
            <TaskCompletionButton task={subtask} collectionId={collectionId}
                onToggleComplete={onToggleSubtask} />
            <span>{subtask.title}</span>
            {children.length > 0 && <button type="button" className="schedule-subtask-children-toggle"
                onClick={() => setExpanded((current) => !current)} aria-expanded={expanded}>
                <FontAwesomeIcon icon={expanded ? faChevronDown : faChevronRight} />
            </button>}
        </div>
        {expanded && children.length > 0 && <ScheduleSubtasks collectionId={collectionId}
            onToggleSubtask={onToggleSubtask} subtasks={children} />}
    </div>;
};

export const ScheduleSubtasks: React.FC<ScheduleSubtasksProps> = ({
    collectionId, onToggleSubtask, subtasks,
}) => (
    <div className="schedule-subtasks" onClick={(event) => event.stopPropagation()}>
        {subtasks.map((subtask) => <ScheduleSubtask key={subtask.id} subtask={subtask}
            collectionId={collectionId} onToggleSubtask={onToggleSubtask} />)}
    </div>
);
